import { LanguageSelector, loginBg, Logo, LogoFooter, MySquid, onConfigChange, simbolSvg, ToggleTheme } from '@hub/shared'
import ContractPage from '@pages/contract/contract.page'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useNavigate } from 'react-router'
import { Route, Routes } from 'react-router-dom'
import { SubscriptionLike } from 'rxjs'
import './contract.layout.scoped.scss'
import './contract.layout.scss'

export default (props: any) => {
  const onConfigChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const [configs, setConfig] = useState<MySquid | null>(null)
  const { i18n } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    onConfigChangeSubscription.current = onConfigChange.subscribe((configChanged: MySquid | any) => {
      if (configChanged?._id) {
        setConfig(configChanged)
      }
    })
    return () => {
      onConfigChangeSubscription?.current?.unsubscribe()
    }
  }, [onConfigChangeSubscription])

  if (props?.general?.maintenance) {
    navigate('/error/maintenance')
  }

  return (
    <div className="contract-layout">
      <style>
        {`.bg {
            background-image:
              linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3) 100%),
              url(${configs?._id ? configs?.images?.backgroundDesktop?.url : loginBg}),
              url(${configs?._id && configs?.graphics ? simbolSvg : null});
          }
          @media (max-width: 991px) {
            .bg {
              background-image:
                url(${configs?._id ? configs?.images?.backgroundMobile?.url : loginBg}),
                url(${configs?._id && configs?.graphics ? simbolSvg : null});
            }
          }
        `}
      </style>
      <figure className="image bg" />
      <main className="container">
        <div className="content">
          <header>
            <Logo style={{ maxWidth: 'initial' }} />
          </header>
          <Routes>
            <Route path={'/:id'} element={<ContractPage {...props} />} />
            <Route path={'/'} element={<Navigate to="/contract/plataform" />} />
            <Route element={<Navigate to="/error/not-found" />} />
          </Routes>
        </div>
        <footer>
          <a href="https://squidit.com.br" target="_blank">
            <LogoFooter />
          </a>
          <ToggleTheme />
          <LanguageSelector lang={i18n.language as any} />
        </footer>
      </main>
    </div>
  )
}
